export default "__VITE_ASSET__lAjpVi$C__"